import { Button, Notice } from "@appkit4/react-components";
import { useNavigate } from "react-router-dom";
import {
  getCurrentPeriodIsReadonly,
  getUserIsReadonly,
  getViewMode,
} from "../services/GroupContext";

const ReadonlyBanner = () => {
  const navigate = useNavigate();
  const isViewModeOn = getViewMode();
  const showBanner =
    getCurrentPeriodIsReadonly() && !getUserIsReadonly() && !isViewModeOn;

  return (
    showBanner && (
      <Notice
        message={
          <div className="space-between notice-content-width">
            <p>
              This period is finalised. To enable editing, open the period from
              the Group POA page.
            </p>
            <Button onClick={() => navigate("/app/grouppoa")}>
              Go to Group POA
            </Button>
          </div>
        }
        status="icon-warning-fill"
        closeable={false}
        style={{ backgroundColor: "white", width: "100%" }}
      />
    )
  );
};

export default ReadonlyBanner;
